import React from 'react';
import './load-more-btn.scss';

const LoadMoreBtn = ({fetchReviews, type, lastReview, pathFinderConfig}) => {
    const handleFetchReviews = (e) => {
        e.preventDefault();
        fetchReviews(e, type, lastReview, pathFinderConfig);
    };

    return (
        <div className="load-more-wrapper">
            <a href="#!" className="js-gtm-event-auto" onClick={handleFetchReviews} data-gtm-category="gig-page-gig_tracking_type" data-gtm-action="click" data-gtm-label="reviews-show-more">{i18n.t('reviews.general.see_more')}</a>
        </div>
    );
};

export default LoadMoreBtn;



// WEBPACK FOOTER //
// ./src/reviews/reviews_list/load_more_btn/LoadMoreBtn.js